const statusobj = Object.freeze({
  waitJump: 'waitJump',
  waitClick: 'waitClick',
  sourceSend: 'sourceSend',
  storageSend: 'storageSend',
  noAdd: 'noAdd',
  default: 'default',
})

const userTypeobj = Object.freeze({
  1: '医院',
  2: '科室',
  3: '医生',
  11: '商务',
})
// /home /doctor-home /doctor/album_detail /department-home /hospital-home /publication-detail/paper book /active-detail /activity-summary /active-live-time
// /login
const canSendPaths = [
  '/home',
  '/doctor-home',
  '/doctor/album_detail',
  '/department-home',
  '/hospital-home',
  '/publication-detail/paper',
  '/publication-detail/book',
  '/publication-detail/guide',
  '/publication-detail/consensus',
  '/active-detail',
  '/activity-summary',
  '/active-live-time',
]

class AllPagePoint {
  constructor () {
    this._sensors = null
    this._ownerMessages = null
    this._waitTime = 3
    this._setTimeout = null
    this._currentType = statusobj.default
  }

  updateSensors (sensors) {
    if (!this._sensors) {
      this._sensors = sensors
    }
  }

  updateLoaclPath (path) {
    console.log('********path*********')
    console.log(path)

    if (path === '/login') {
      // this.cancelStatusDefault()
      this._currentType = statusobj.waitClick
    } else if (canSendPaths.includes(path)) {
      if (!(/send/giu).test(this._currentType)) {
        this._currentType = statusobj.waitJump
      }
    }
  }

  getLoginType (type) {
    switch (type) {
      case 'phone':
        return '手机号验证码登录'
      case 'wx':
        return '微信登录'
      default:
        return '账号密码登录'
    }
  }

  getOperationData (list) {
    return list.reduce(
      (acc, v) => {
        let currentName = `${v.modeOneName ? v.modeOneName : ''}${
          v.modeTwoName ? '-' + v.modeTwoName : ''
        }`
        if (v.isMain) {
          acc.main = currentName
        } else {
          acc.list.push(currentName)
        }
        return acc
      },
      { main: '', list: [] }
    )
  }

  // LoginResult 登录-注册结果自定义事件 sendData 参数is_first_login type result
  loginResultSuccess (resData = {}, sendData = {}) {
    this.sensorsProfileData(resData)
    this._currentType = statusobj.sourceSend
    let needData = {}
    needData.login_type = this.getLoginType(sendData.type)
    needData.is_first_login = sendData.is_first_login
    needData.user_type = userTypeobj[resData.userType]
    needData.login_result = '成功'
    localStorage.setItem('sensors_send_success_message', JSON.stringify(needData))
    this.sendLogin(resData.userId)
    this.sendLoginResult(needData)
    console.log(needData)
  }

  loginResultSuccessAsyn (resData = {}, sendData = {}) {
    return new Promise((s, _) => {
      this.loginResultSuccess(resData, sendData)
      setTimeout(() => {
        s(true)
      }, 500)
    })
  }

  loginResultError (data = {}) {
    let needData = {}
    needData.login_result = '失败'
    needData.fail_reason = data.message
    if (data.hasOwnProperty('type')) {
      needData.login_type = this.getLoginType(data.type)
    }
    this.sendLoginResult(needData)
    console.log(needData)
  }

  sendLogin (userId) {
    if (this._sensors) {
      this._sensors.login(userId)
    }
  }

  sendLoginResult (data = {}) {
    if (this._sensors) {
      this._sensors.track('LoginResult', data)
    }
  }

  /**
     *
     * 视频播放时间开始结束 埋点
     */
  videoTime (data = {}, type) {
    if (this._sensors) {
      if (type === 'start') {
        this._sensors.track('VideoStart', data)
      } else {
        this._sensors.track('VideoEnd', data)
      }
    }
  }

  videoStart (data = {}, sendData = {}) {
    let needData = this.videoOwnSensors(data, sendData)
    this.videoTime(needData, 'start')
  }

  videoEnd (data = {}, sendData = {}) {
    let needData = this.videoOwnSensors(data, sendData)
    this.videoTime(needData, 'end')
  }

  // video Sensors参数处理
  videoOwnSensors (data = {}, sendData = {}) {
    let needData = {}
    needData.content_id = data.worksId
    needData.content_name = data.title
    needData.content_type = sendData.content_type
    needData.content_status = sendData.content_type === '视频' ? '视频（审核通过）' : '直播时刻&手术&会议&微课（回看）'
    needData.video_duration = sendData.video_duration
    sendData.play_duration && (needData.play_duration = sendData.play_duration)
    return needData
  }

  /**
     * H5互动埋点
     */

  contentInteract (data = {}) {
    if (this._sensors) {
      this._sensors.track('ContentInteract', data)
    }
  }

  /**
     * H5曝光埋点
     */

  contentExposure (data = {}) {
    if (this._sensors) {
      this._sensors.track('ContentExposure', data)
    }
  }

  getLocalUserInfo () {
    let currentUser = window.localStorage.getItem('sensors_send_success_message')
    try {
      currentUser = JSON.parse(currentUser)
      this._ownerMessages = currentUser
    } catch (error) {
    }
  }

  statusDefault () {
    this._setTimeout = setTimeout(() => {
      this.defaultSendMessage()
      this._currentType = statusobj.storageSend
      // console.log('==---')
    }, this._waitTime * 1000)
  }

  cancelStatusDefault () {
    this._setTimeout && clearTimeout(this._setTimeout)
    this._setTimeout = null
  }

  defaultSendMessage () {
    this.getLocalUserInfo()
    if (this._ownerMessages) {
      console.log('********&&&^^^^%%%%$$$')
      this.sendLoginResult(this._ownerMessages)
    }
  }

  // getLocalUserInfo () {
  //   let currentUser = window.localStorage.getItem('userInfo')
  //   try {
  //     currentUser = JSON.parse(currentUser)
  //     this._ownerMessages = currentUser
  //   } catch (error) {}
  // }
  //
  // statusDefault () {
  //   this._setTimeout = setTimeout(() => {
  //     this.defaultSendMessage()
  //     this._currentType = statusobj.storageSend
  //     // console.log('==---')
  //   }, this._waitTime * 1000)
  // }

  // cancelStatusDefault () {
  //   this._setTimeout && clearTimeout(this._setTimeout)
  //   this._setTimeout = null
  // }

  // defaultSendMessage () {
  //   this.getLocalUserInfo()
  //   if (this._ownerMessages) {
  //     this.sensorsProfileData(this._ownerMessages)
  //   }
  // }

  // 更新注册表信息
  sensorsProfileData (sourceData) {
    if (this._sensors && sourceData) {
      let data = this.loginResultData(sourceData)
      this._sensors.setProfile(data)
      this._sensors.setOnceProfile({ signup_time: sourceData.createdOn })
      console.log('更新注册表信息sensorsProfileData--->data', data)
    }
  }

  loginResultData (data) {
    // user_code  user_type  user_level  key_operation  perfer_operation  level  department  hospital  is_bigv  is_new  nick_name  sales  area
    const currentUserType = userTypeobj[data.userType]
    const currentIsDoctor = currentUserType === '医生'

    let needData = {}

    needData.user_code = data.userId
    needData.user_type = currentUserType
    needData.nick_name = data.nickname
    needData.sales = data.registerInvitationCode
    needData.area = `${data.areaProvince}${data.areaCity}`

    if (currentIsDoctor) {
      needData.user_level = `v${data.honorLevel}`
      needData.level = data.doctorTitle
      needData.department = data.departmentName
      needData.hospital = data.hospitalName
      needData.is_bigv = data.isStarDoctor === 1
      // 术士
      // key_operation perfer_operation
      if (data.isSelectMode === 1) {
        let { main, list } = this.getOperationData(data.modeVOList)
        needData.key_operation = main
        list.length && (needData.perfer_operation = list)
      }
    }
    if (currentUserType === '医生' || currentUserType === '商务') {
      needData.is_new = data.isNew === 1
    }
    return needData
  }

  /**
     * @param {string} val
     */
  set _currentType (val) {
    switch (val) {
      case 'waitJump':
        this.statusDefault()
        break
      case 'waitClick':
        this.cancelStatusDefault()
        break
      default:
        break
    }
    console.log(val)
  }

  /**
     * 话题详情/首页 列表曝光打点
     * @param data
     */
  listShow (data) {
    if (this._sensors) {
      this._sensors.track('ListShow', data)
    }
  }

  /**
     * 话题详情/首页 列表曝光打点
     * @param data
     */
  bannerShow (data) {
    if (this._sensors) {
      this._sensors.track('BannerShow', data)
    }
  }

  heatMapClick (data) {
    if (this._sensors) {
      this._sensors.track('HotClick', data)
    }
  }

  /**
     * 唤醒APP
     * @param data
     */
  awakenApp (data) {
    if (this._sensors) {
      this._sensors.track('AwakenApp', data)
    }
  }

  /**
     * 唤醒APP结果
     * @param data
     */
  awakenAppResult (data) {
    if (this._sensors) {
      this._sensors.track('AwakenAppResult', data)
    }
  }

  /**
     * 新用户推荐关注
     * @param data
     */
  nuFollow (data) {
    if (this._sensors) {
      this._sensors.track('NUFollow', data)
    }
  }

  registrationProcessClick (data) {
    if (this._sensors) {
      this._sensors.track('RegistrationProcessClick', data)
    }
  }

  userRousebyLive (data) {
    if (this._sensors) {
      this._sensors.track('userRousebyLive', data)
    }
  }

  // 热图埋点
  hotBrowse (data) {
    if (this._sensors) {
      this._sensors.track('HotBrowse', data)
    }
  }

}

const newAllPagePoint = new AllPagePoint()

export default newAllPagePoint
